import { useEffect, useRef, useState } from "react";
import usePaginationFilter from "../../../../../hooks/usePaginationFilter";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
    IContato,
    IFiltroListarContatos,
} from "../../../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import {
    DesvincularContatosController,
    ListarContatosFiltroController,
    VincularContatosController,
} from "../../../../../Controllers/Automacao/Contato/ContatoControllers";
import StorageManagerCapys from "../../../../../Tools/Storage";

interface RouteParams {
    idAudiencia: string;
}
export function useVincularDesvincularContatos() {
    const { PageFilter, setPage } = usePaginationFilter({ page: 1 });
    const [lstContato, setLstContato] = useState<Array<IContato>>([]);
    const [lstIdContatoSelected, setLstIdContatoSelected] = useState<
        Array<number>
    >([]);
    const [loading, setLoading] = useState(false);
    const params = useParams<RouteParams>();
    const { idAudiencia } = params;
    const location = useLocation();
    const history = useHistory();
    const [listIdEmpreedimento, setListIdEmpreedimento] = useState<number[]>(
        []
    );

    const filtroInicial = {
        QUANTIDADE: 10,
        PAGINA: PageFilter.page,
        ID_CONTA: 0,
        DS_NOME_CONTATO: "",
        ID_EMPREENDIMENTOS: [],
        ID_TIPO_CONTA: 0,
        ID_PERFIL_FINANCEIRO_CONTA: 0,
        ID_ETAPA_JORNADA: 0,
        NR_UNIDADES_INICIAL: 0,
        NR_UNIDADES_FINAL: 0,
        VL_VGV_TOTAL_INICIAL: 0,
        VL_VGV_TOTAL_FINAL: 0,
        ID_AUDIENCIA: Number(idAudiencia),
        FL_VINCULADO:
            location.pathname.split("/")[2] === "VincularContatos"
                ? false
                : true,
    };

    const filtroGestaoStorage = new StorageManagerCapys<IFiltroListarContatos>(
        `FILTRO_CONTATO`,
        "session"
    );
    const filter = useRef<IFiltroListarContatos>(
        filtroGestaoStorage.get() ?? filtroInicial
    );

    const updateList = (filter: IFiltroListarContatos, page: number) => {
        setLoading(true);
        ListarContatosFiltroController({
            ...filter,
            PAGINA: page,
            ID_AUDIENCIA: Number(idAudiencia),
            ID_EMPREENDIMENTOS: listIdEmpreedimento,
            FL_VINCULADO:
                location.pathname.split("/")[2] === "VincularContatos"
                    ? false
                    : true,
        })
            .then((res: Array<IContato>) => {
                setLstContato(res);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    };

    const VincularDesvicularContato = () => {
        if (location.pathname.split("/")[2] === "VincularContatos") {
            VincularContatosController(
                Number(idAudiencia),
                lstIdContatoSelected
            ).then((res) => {
                history.push(`/Automacao/${Number(idAudiencia)}/Contatos`);
            });
        } else {
            DesvincularContatosController(
                Number(idAudiencia),
                lstIdContatoSelected
            ).then((res) =>
                history.push(`/Automacao/${Number(idAudiencia)}/Contatos`)
            );
        }
    };

    useEffect(() => {
        updateList(filter.current, PageFilter.page);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PageFilter, filter]);

    const totalPaginas = lstContato ? lstContato[0]?.NR_PAGINAS || 1 : 1;
    return {
        totalPaginas,
        setListIdEmpreedimento,
        setLstIdContatoSelected,
        VincularDesvicularContato,
        loading,
        location,
        filter,
        listIdEmpreedimento,
        filtroInicial,
        lstContato,
        updateList,
        filtroGestaoStorage,
        setPage,
    };
}
